import useSWR from "swr";
import { instance } from "./data";
import { useContext } from "react";
import TenantContext from "../context/tenant";
import { useAuth0 } from "@auth0/auth0-react";
import useSWRMutation from "swr/mutation";
import AdminContext from "../context/admin";

export default function useChatData() {
  const { id } = useContext(TenantContext);
  const { emulatingUser } = useContext(AdminContext);
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();

  const fetcher = async ({ url, tenantId, accessTokenFunc }: any) => {
    const accessToken = await accessTokenFunc({
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      scope: "write:profile-data",
    });
    const { data } = await instance.get(url, {
      headers: {
        "X-Tenant-Id": tenantId,
        "X-Emulating-User-Id": emulatingUser && "user_id" in emulatingUser ? emulatingUser.user_id : "",
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return data;
  };

  const updater = async (
    { url, tenantId, accessTokenFunc }: any,
    { arg }: any,
  ) => {
    const accessToken = await accessTokenFunc({
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      scope: "write:profile-data",
    });
    const { data } = await instance.post(
      url,
      {
        email_address: user?.email,
        tenant_id: tenantId,
        ...arg,
      },
      {
        headers: {
          "X-Tenant-Id": tenantId,
          "X-Emulating-User-Id": emulatingUser && "user_id" in emulatingUser ? emulatingUser.user_id : "",
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  };

  const { data, mutate } = useSWR(
    id && isAuthenticated
      ? {
          url: "/api/v2/chat",
          tenantId: id,
          accessTokenFunc: getAccessTokenSilently,
        }
      : null,
    fetcher,
  );

  const { trigger } = useSWRMutation(
    id && isAuthenticated
      ? {
          url: "/api/v2/chat",
          tenantId: id,
          accessTokenFunc: getAccessTokenSilently,
        }
      : null,
    updater,
  );

  return {
    chatData: data,
    mutateChatData: mutate,
    triggerUpdateChatData: trigger,
  };
}
